import { AppLayout } from "../../components/layout/AppLayout";
import { CompanyInteractiveList } from "../../components/suporte/CompanyInteractiveList";
import { ActionsModulePlaceholder } from "./modulos/ActionsModulePlaceholder";
import { KnowledgeBaseModulePlaceholder } from "./modulos/KnowledgeBaseModulePlaceholder";
import { TicketsModulePlaceholder } from "./modulos/TicketsModulePlaceholder";

export function SupportHomePage() {
  return (
    <AppLayout>
      <CompanyInteractiveList />
      <section className="modules-grid">
        <TicketsModulePlaceholder />
        <KnowledgeBaseModulePlaceholder />
        <ActionsModulePlaceholder />
      </section>
    </AppLayout>
  );
}
